/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Batch_Result_TitleInputs */



/**
* | output |
* | --- |
* | "Some Uploads Failed" |
*
* @param {Embed_Captions_Batch_Result_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_batch_result_title = /** @type {((inputs?: Embed_Captions_Batch_Result_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Batch_Result_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Certains envois ont échoué")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einige Uploads sind fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Alcuni caricamenti non sono riusciti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Некоторые загрузки не удались")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algunas cargas fallaron")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("部分上传失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一部のアップロードに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुछ अपलोड विफल रहे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alguns carregamentos falharam")
	return /** @type {LocalizedString} */ ("Some Uploads Failed")
});